<template><div>
  <loading v-if="loading" />
  <div v-else-if="!users">
    An error occurred loading the user list. <button @click="loadUsers">Try Again</button>
  </div>
  <div v-else class="user-list">
    Click one of the users below to log in as that user:
    <button
        v-for="u in users"
        :key="`u-${u[0]}`"
        @click="impersonate(u)">
      {{ u[1] || '-' }} {{ u[2] || '-' }} ({{ u[0] }})
    </button>
    <form action="/user" method="POST" ref="impersonateForm">
    <input type="hidden" name="csrfmiddlewaretoken" :value="csrftoken" />
    <input type="hidden" name="action" value="impersonate" />
    <input type="hidden" name="email" v-model="email" />
    </form>
  </div>
</div></template>
<script>
import api from '../../api'
import Cookies from 'js-cookie'
import Loading from '../Loading'
export default {
  name: 'admin-login',
  components: { Loading },
  data() {
    return {
      loading: false,
      users: false,
      email: '',
    }
  },
  computed: {
    csrftoken: () => Cookies.get('csrftoken'),
  },
  created() {
    this.loadUsers()
  },
  methods: {
    async loadUsers() {
      this.loading = true
      this.users = null
      try {
        this.users = await api.getAllUsers()
      } catch(e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    impersonate(u) {
      this.email = u[0]
      this.$nextTick(() => {
        this.$refs.impersonateForm.submit()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.user-list button {
  margin: 0 5px 5px 0;
}
</style>
